module.exports = __webpack_public_path__ + "static/media/purchase-order_icon_purple.3e963443.png";